import {
  APP_PERMISSIONS,
  CREDIT_PERMISSIONS,
  CRT_PERMISSIONS,
  type AppRolePermissions,
  type CreditRolePermissions,
  type CrtRolePermissions,
  type UserPermissions,
} from './permissions'

/**
 * Role files only declare their own module's permissions (AppRolePermissions,
 * CrtRolePermissions or CreditRolePermissions), but every downstream consumer
 * expects the full UserPermissions shape (all keys). These builders fill in the
 * other modules' permissions as `false` so the exported ROLE_PERMISSIONS object
 * stays backward-compatible.
 */

const appDefaults = Object.fromEntries(APP_PERMISSIONS.map((p) => [p, false]))
const crtDefaults = Object.fromEntries(CRT_PERMISSIONS.map((p) => [p, false]))
const creditDefaults = Object.fromEntries(CREDIT_PERMISSIONS.map((p) => [p, false]))

export function buildAppRolePermissions(perms: AppRolePermissions): UserPermissions {
  return { ...perms, ...crtDefaults, ...creditDefaults } as UserPermissions
}

export function buildCrtRolePermissions(perms: CrtRolePermissions): UserPermissions {
  return { ...appDefaults, ...perms, ...creditDefaults } as UserPermissions
}

export function buildCreditRolePermissions(perms: CreditRolePermissions): UserPermissions {
  return { ...appDefaults, ...crtDefaults, ...perms } as UserPermissions
}
